import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { deleteUser, getAllUsers } from "../../../../api/usersAPIs";
import {
  BlockBetween,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PreviewCard,
  ReactDataTable,
  UserAvatar,
} from "../../../../components/Component";
import DeleteModal from "../../../../components/DeleteModal";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";

const UserList = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const toggleDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen);

  const handleDelete = async (user) => {
    try {
      console.log("user", user);
      await deleteUser({ userId: user._id });
      setUsers((prev) => prev.filter((u) => u._id !== user._id));
      toast.success("User deleted successfully");
    } catch (error) {
      toast.error("Failed to delete user: " + error.message);
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const response = await getAllUsers();
        const fetchedUsers = response.data.data;
        setUsers(fetchedUsers);
      } catch (error) {
        console.error("Failed to fetch users:", error);
        toast.error("Failed to fetch users");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const columns = [
    {
      name: "Name",
      selector: (row) => `${row.first_name} ${row.last_name}`,
      cell: (row) => (
        <div className="d-flex justify-center align-center">
          <UserAvatar text={`${row.first_name[0]}`} />
          <div className="ps-1">{`${row.first_name} ${row.last_name}`}</div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Role",
      selector: (row) => row.role,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => navigate(`/edit-user/${row._id}`)}
          >
            <i className="bi bi-pencil-fill"></i>Edit
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => {
              setSelectedUser(row);
              toggleDeleteModal();
            }}
          >
            <i className="bi bi-trash-fill"></i>Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Head title="User List"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                User List
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>You have a total of {users.length} users.</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button color="success" onClick={() => navigate("/add-user")}>
                Add User
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <BlockContent>
          <PreviewCard>
            {loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
                <div className="text-center">
                  <div
                    className="spinner-grow text-primary"
                    style={{ width: "3rem", height: "3rem" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3 text-muted">Loading users, please wait...</p>
                </div>
              </div>
            ) : (
              <ReactDataTable
                data={users}
                columns={columns}
                pagination
                highlightOnHover
              />
            )}
          </PreviewCard>
        </BlockContent>
      </Content>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        toggle={toggleDeleteModal}
        onConfirm={() => handleDelete(selectedUser)}
        item={selectedUser}
      />
    </React.Fragment>
  );
};

export default UserList;